import UpdateBasketItemRequestModel from '../../../generated/types/model/request/UpdateBasketItemRequestModel';

export default class UpdateBasketItemRequestViewModel extends UpdateBasketItemRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
